import React, { useState, useEffect } from "react";
import {
  showToast,
  showAlert,
  formatComment,
  sanitizeInput
} from "../../utils/utils";
import { useParams } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import PropTypes from "prop-types";
import privateAxios from "../../utils/axiosPrivate";
import styles from "./../../assets/scss/custom.module.scss";
import "./inv-comment.scss";
import { alertActions, customersDtls, financeTab } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import {
  getDeletePaymentCommentUrl,
  getPostPaymentCommentUrl
} from "../../utils/constants/apiEndPoints";

const InvoicePaymentComment = (props) => {
  const { id } = useParams();
  const {
    titleText,
    addText,
    placeholder,
    addBtnText,
    responseMsg,
    typeCmntProp,
    sureDeleteMsg,
    invData,
    fetchInvoiceData
  } = props;
  const typeCmnt = typeCmntProp;
  const numericId = id ? parseInt(id, 10) : null;
  const [show, setShow] = useState(false);

  const initialAllComment = {
    userAccountId: numericId,
    commentType: typeCmnt,
    comment: "",
    createdBy: numericId
  };

  const [allComment, setAllComment] = useState(initialAllComment);
  const [comments, setComments] = useState([]);

  // Update allComment when numericId or typeCmnt changes
  useEffect(() => {
    setAllComment((prev) => ({
      ...prev,
      userAccountId: numericId,
      commentType: typeCmnt,
      createdBy: numericId
    }));
  }, [numericId, typeCmnt]);

  // Fetch comments when id and typeCmnt are available
  useEffect(() => {
    if (invData?.paymentComment?.comments) {
      setComments(invData.paymentComment.comments);
    }
  }, [invData]);

  function toggleShow() {
    setShow(!show);
  }

  function handleTextareaChange(event) {
    setAllComment({
      ...allComment,
      comment: event.target.value
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newComment = allComment.comment.trim();
    if (newComment) {
      try {
        const formattedComment = formatComment(newComment);
        const dataToSend = {
          ...allComment,
          comment: sanitizeInput(formattedComment)
        };

        // Make the API call to save the comment
        const response = await privateAxios.post(
          getPostPaymentCommentUrl(id),
          dataToSend
        );

        const addedComment = response.data.data;
        setComments([addedComment, ...comments]);
        setShow(false);
        setAllComment({
          ...allComment,
          comment: ""
        });
        showToast(
          `${responseMsg} ${financeTab.creditScore.finacialComment}`,
          showToastType.success
        );
      } catch (error) {
        if (error.response && !error.response.status === 404) {
          showToast(error.message, showToastType.error);
        }
      }
    }
  };

  const handleDeleteClick = async (commentId) => {
    try {
      const result = await showAlert(
        "",
        `${sureDeleteMsg}`,
        alertActions?.warning,
        alertActions?.Confirm,
        alertActions?.Cancel
      );

      if (result.isConfirmed) {
        await privateAxios.delete(getDeletePaymentCommentUrl(id, commentId));
        showToast(showToastType.commentDelete, showToastType.success);
        fetchInvoiceData();
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        const apiFieldErrors = error.response.data.errors[0];
        showToast(apiFieldErrors, showToastType.error);
      }
    }
  };

  const buttonText = show
    ? customersDtls.noteCmmnt.CloseBtn
    : `${customersDtls.noteCmmnt.add} ${addText}`;

  return (
    <>
      <div className={styles.editCommentwrap}>
        <div className={`${styles.labelTitle} mb-0 pb-0`}>
          <h5>
            {titleText}
            <button className={styles.commentAddbtn} onClick={toggleShow}>
              [ {buttonText} ]
            </button>
          </h5>
        </div>
      </div>
      {show && (
        <div className={`${styles.commentArea} ${styles.showCommentArea} my-2`}>
          <textarea
            placeholder={placeholder}
            value={allComment?.comment}
            onChange={handleTextareaChange}
          />
        </div>
      )}
      {show && (
        <div className={`${styles.commentSubmit}`}>
          <button className="btn-primary btn" onClick={handleSubmit}>
            {addBtnText}
          </button>
        </div>
      )}
      <div className="mb-3 mt-3 cmnt_details">
        {comments.map((c) => (
          <div
            key={c.id}
            id={c.id}
            className={`${styles.commentUpdate} mb-1 pb-1 pt-1 d-flex justify-content-between align-items-center`}
          >
            <div className="cmnt-note pe-2">
              <p
                dangerouslySetInnerHTML={{ __html: sanitizeInput(c.comment) }}
              />
            </div>
            <div className="cmnt-action">
              <ul
                className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
              >
                <li>
                  <button
                    className={`${styles.btnPrimary} added-icon`}
                    onClick={() => handleDeleteClick(c.id)}
                  >
                    <FaTimes />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

InvoicePaymentComment.propTypes = {
  titleText: PropTypes.string.isRequired,
  addText: PropTypes.string,
  placeholder: PropTypes.string,
  addBtnText: PropTypes.string,
  responseMsg: PropTypes.string,
  typeCmntProp: PropTypes.string.isRequired,
  sureDeleteMsg: PropTypes.string.isRequired,
  invData: PropTypes.object,
  fetchInvoiceData: PropTypes.func.isRequired
};

export default InvoicePaymentComment;
